import api, { checkTokenErrorResponse } from '..';

export async function postClass(nome, numero_vagas, tipo, faixa_etaria) {
    return api.post("turmas/", {
        nome,
        tipo,
        numero_vagas,
        faixa_etaria,
    })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getClasses() {
    return api.get("turmas/")
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getClassInfos(id) {
    return api.get(`turmas/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getClassStudents(id) {
    return api.get(`turmas/${id}/alunos/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function patchClass(id, nome, numero_vagas, tipo, faixa_etaria) {
    return api.patch(`turmas/${id}/`, {
        nome,
        numero_vagas,
        tipo,
        faixa_etaria,
    })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function deleteClass(id) {
    return api.delete(`turmas/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

const classServices = {
    postClass,
    getClasses,
    getClassInfos,
    getClassStudents,
    patchClass,
    deleteClass,
}
export default classServices;